import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {getExtendedClass, getWarrantyPeriod, getWithoutClass} from './utils.js'

export const CardAdPriceWarranty = ({
  vertical,
  hasWarranty,
  hasOfficialWarranty,
  warrantyLiteral,
  warrantyMonths,
  isPreview
}) => {
  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const {SHOW_WARRANTY} = config.get('search')

  const warrantyClass = getWithoutClass({
    className: 'mt-CardAdPrice-infoItem',
    isWithout: !hasWarranty || !(warrantyMonths || isPreview)
  })

  const warrantyLiteralMonths = getWarrantyPeriod({
    i18n,
    months: warrantyMonths,
    forceMonths: true
  })
  const warrantyLiteralYears = getWarrantyPeriod({i18n, months: warrantyMonths})

  if (!SHOW_WARRANTY) return null

  return (
    <div
      className={getExtendedClass({
        warranty: true,
        vertical,
        highlighted: !warrantyMonths
      })}
    >
      <span className={warrantyClass}>
        {hasOfficialWarranty ? i18n.t('COMMON.OFFICIAL_WARRANTY') : warrantyLiteral}
      </span>
      <p className="mt-CardAdPrice-extendedAmount">{warrantyLiteralYears}</p>
      <span className="mt-CardAdPrice-extendedFooter">{warrantyLiteralMonths}</span>
    </div>
  )
}

CardAdPriceWarranty.propTypes = {
  vertical: PropTypes.bool,
  hasWarranty: PropTypes.bool,
  hasOfficialWarranty: PropTypes.bool,
  warrantyLiteral: PropTypes.string,
  warrantyMonths: PropTypes.number,
  isPreview: PropTypes.bool
}
